"use client";

import React from "react";
import Link from "next/link";
import { ArrowRight, Sparkles } from "lucide-react";

interface MidPostCTAProps {
  title?: string;
  description?: string;
  buttonText?: string;
  href?: string;
}

export const MidPostCTA = ({
  title = "Ready to build your social media second brain?",
  description = "Tavlo helps you capture, distill, and organize everything that resonates with you across social media.",
  buttonText = "Try Tavlo for Free",
  href = "/sign-in",
}: MidPostCTAProps) => {
  return (
    <div className="my-16 p-8 md:p-10 rounded-[2rem] bg-gradient-to-br from-brand-1/[0.08] via-white/[0.02] to-brand-3/[0.05] border border-brand-1/15 relative overflow-hidden group">
      <div className="absolute top-0 right-0 w-32 h-32 bg-brand-1/10 rounded-full blur-3xl -mr-16 -mt-16 group-hover:bg-brand-1/20 transition-colors" />

      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex-1 text-center md:text-left">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-1/10 border border-brand-1/20 text-brand-1 text-[10px] font-bold uppercase tracking-widest mb-4">
            <Sparkles className="w-3 h-3" />
            Boost Your Productivity
          </div>
          <h3 className="text-2xl font-bold text-white mb-3 tracking-tight">
            {title}
          </h3>
          <p className="text-text-secondary text-sm leading-relaxed max-w-md">
            {description}
          </p>
        </div>

        <div className="shrink-0 w-full md:w-auto">
          <Link
            href={href}
            className="flex items-center justify-center gap-2 px-8 py-4 bg-brand-1 text-white font-bold rounded-2xl hover:shadow-[0_0_30px_-5px_rgba(91,91,255,0.5)] transition-all duration-300 group/btn"
          >
            {buttonText}
            <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MidPostCTA;
